import { secureStore, onSecureStoreCorrupted } from '@/platform/secure-store'

export { onSecureStoreCorrupted }

// Backwards-compatible facade over the platform secure store. On Android the
// values live in Keystore-encrypted SharedPreferences; on web the session is
// carried by the HttpOnly cookie and only mirrored in memory.
export const secureTokenStore = {
  async setToken(token: string) {
    if (token) await secureStore.setItem('token', token)
    else await secureStore.removeItem('token')
  },
  async getToken() {
    return secureStore.getItem('token')
  },
  async removeToken() {
    await secureStore.clear()
  },
}
